import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, darkGrayFontColor } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	buttons: {
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	container: {
		maxWidth: 550,
	},
	delete: {
		alignItems: 'center',
		color: '#D0021B',
		cursor: 'pointer',
		display: 'flex',
		fontSize: 12,
		fontWeight: 'normal',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	description: {
		color: darkGrayFontColor,
		fontSize: 12,
		lineHeight: '18px',
		paddingTop: 11,
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: 22,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	settings: {
		borderTop: '1px solid #F2F2F2',
		marginTop: 11,
		paddingTop: 16,
	},
	tag: {
		display: 'flex',
		marginTop: 10,
	},
	title: {
		color: brandPrimaryText,
		fontSize: 18,
		fontWeight: 'normal',
		lineHeight: '20px',
	},
	validEmailOnlyCheckbox: {
		minWidth: 200,
		paddingLeft: 16,
	},
	verticalCenter: {
		alignItems: 'center',
		display: 'flex',
	},
});
